import { GrowthBook } from "@growthbook/growthbook";
import { BrowserCookieStickyBucketService } from "@growthbook/growthbook";
import Cookies from 'js-cookie';
import * as features from "@/scripts/store/features";
import { head } from "underscore";

const growth_book = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: "sdk-bFMPGDFC9sMwhjsE",
  enableDevMode: process.env.NODE_ENV === "development",
  subscribeToChanges: true,
  stickyBucketService: new BrowserCookieStickyBucketService({
    jsCookie: Cookies,
  }),
  trackingCallback: (experiment, result) => {
    console.log('viewed experiment', experiment.key, result.key);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "viewed_experiment",
      experimentId: experiment.key,
      variationId: result.key
    });
  }
});

window.gb = growth_book; // Expose for debugging
window.growth_book = growth_book; // Expose for debugging

//===========================
// Collect user attributes
//===========================

//should match tailwind.config.js
const screens = {
  'sm': '700px',
  'md': '1000px',
  'lg': '1150px',
  'xl': '1400px',
  '2xl': '1600px',
}

const screenSize = Object.keys(screens).reverse().find((key) => {
  return window.innerWidth > parseInt(screens[key]);
});

const getHeapIdFromStorage = function() {
  try {
    const meta = JSON.parse(localStorage.getItem('_hp5_meta.1902471082')); // TODO: don't use hardcoded heap instance ID
    return meta?.value?.userId || null;
  } catch(e) {
    //do nothing
  }
  return null;
}

const waitForHeapId = function(){
  console.log("hello");

  const storedId = getHeapIdFromStorage();
  if (storedId) {
    console.log('Heap ID found in localStorage');
    setGbAttributes(storedId);
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    if(window.heapLoaded){
      console.log('Heap already loaded');
      const heapId = window.heap.getUserId();
      setGbAttributes(heapId);
      resolve();
    }else{
      const timeout = setTimeout(() => {
        console.warn("heapReady timeout — proceeding without Heap ID");
        setGbAttributes(null);
        resolve();
      }, 10000);

      window.addEventListener("heapReady", function (event) {
        console.log("heapReady event");
        console.log("userID", window.heap.getUserId());
        clearTimeout(timeout);
        const heapId = window.heap.getUserId();
        if (heapId === null) {
          setTimeout(() => {
            setGbAttributes(window.heap.getUserId());
            resolve();
          }, 500);
        } else {
          setGbAttributes(heapId);
          resolve();
        }
      });
    }
  });
}

const setGbAttributes = function(id){
  const attributes = {
    id: id,
    heapId: id || 'unknown',
    email: window?.userAttributes?.email,
    customerId: window?.userAttributes?.customerId,
    totalSpent: window?.userAttributes?.totalSpent,
    ordersCount: window?.userAttributes?.ordersCount,
    tags: window?.userAttributes?.tags,
    country: Shopify.country,
    locale: Shopify?.locale,
    currency: Shopify?.currency?.active,
    url: window.location.href,
    userAgent: navigator.userAgent,
    screenWidth: window.innerWidth,
    screenSize: screenSize,
    themeId: Shopify.theme.id,
    themeName: Shopify.theme.name,
    themeRole: Shopify.theme.role,
    params: paramsToObject(new URL(document.location).searchParams)
  }

  growth_book.setAttributes(attributes);

  try {
    window.heap?.track('growthbook:attributes', attributes);
  } catch (e) {
    console.log('heap not ready?');
  }
}

//===========================
// setup growthbook
//===========================

function paramsToObject(entries) {
  const result = {}
  for(const [key, value] of entries) { // each 'entry' is a [key, value] tupple
    result[key] = value;
  }
  return result;
}

export const setupGrowthbook = async function(){

    window.dispatchEvent(new Event('growthbook:setup'));

    try{
       window.heap?.track("growthbook:setup");
    }catch(e){
      console.log("heap not ready?");
    }

    console.log("setup growthbook");
    await waitForHeapId();
    console.log('heap up');

    // Wait for features to be available
    await growth_book.init({ timeout: 1000 }); 

    for(const key in features){
      const feature = features[key];
      const value = growth_book.getFeatureValue(feature.key);
      if(typeof value != "undefined"){
          feature.init(value);
      }
    }

    growth_book.setRenderer(() => {
      for(const key in features){
          const feature = features[key];
          const value = growth_book.getFeatureValue(feature.key);
          if(typeof value != "undefined"){
              feature.init(value);
          }
      }
    });

    console.log('growthbook ready');

    //publish event that growthbook is ready
    window.dispatchEvent(new Event('growthbook:ready'));

    try {
      window.heap?.track('growthbook:ready');
    } catch (e) {
      console.log("heap not ready?");
    }
}